const fr = {
  nav_about: 'À propos',
  nav_packages: 'Forfaits',
  nav_calculator: 'Calculateur',
  nav_contacts: 'Contact',
  nav_start: 'Commencer à investir',

  hero_badge: 'Tendance saisonnière · Printemps 2025',
  hero_title_1: 'La croissance printanière du',
  hero_title_wheat: 'blé',
  hero_title_2: '— doublez, triplez ou',
  hero_title_3: 'quadruplez',
  hero_title_4: 'votre argent',
  hero_x2_label: '×2 profit',
  hero_x2_from: 'à partir de €21 100',
  hero_x3_label: '×3 profit',
  hero_x3_from: 'à partir de €26 000',
  hero_x4_label: '×4 profit',
  hero_x4_from: 'à partir de €31 000',
  hero_desc: "Historiquement, les prix du blé augmentent au printemps en raison de la hausse de la demande mondiale, de la pression de la saison des semailles et de l'épuisement des stocks hivernaux. Les investisseurs utilisent ce cycle saisonnier chaque année pour multiplier leur capital.",
  hero_cta_calc: 'Calculer le profit maintenant',
  hero_cta_packages: 'Voir les forfaits',
  hero_stat1_val: '+42%',
  hero_stat1_label: 'Croissance printanière moyenne',
  hero_stat2_val: '5+ ans',
  hero_stat2_label: 'Tendance stable',
  hero_stat3_val: 'TOP-1',
  hero_stat3_label: 'Actif agricole mondial',
  hero_chart_title: 'Dynamique du prix du blé · Printemps',
  hero_chart_sub: 'Croissance indexée (Fév. = 100%)',
  hero_chart_avg: '+42% moy.',
  hero_chart_max: '+56%',
  hero_chart_max_label: 'Croissance saisonnière maximale',
  hero_chart_100: '100%',
  hero_chart_100_label: 'Années avec croissance positive',
  hero_scroll: 'défiler vers le bas',

  why_badge: 'Analyse saisonnière',
  why_title_1: 'Pourquoi le blé',
  why_title_2: 'croît-il au printemps ?',
  why_subtitle: 'Cinq facteurs clés formant une tendance de prix stable chaque année',
  why_f1_title: 'Demande en fourrage',
  why_f1_desc: "Au printemps, la demande en fourrage à base de blé augmente fortement des élevages se préparant pour la saison active.",
  why_f1_stat: '+21%',
  why_f1_label: 'croissance de la demande',
  why_f2_title: 'Campagne de semailles',
  why_f2_desc: "Le début de la campagne de semailles printanière crée une effervescence sur le marché et une pression sur les stocks de blé disponibles.",
  why_f2_stat: '+28%',
  why_f2_label: "croissance de l'activité",
  why_f3_title: 'Producteurs alimentaires',
  why_f3_desc: "Les boulangeries et les fabricants alimentaires augmentent leurs achats de blé avant la saison de production estivale.",
  why_f3_stat: '+19%',
  why_f3_label: 'croissance des achats',
  why_f4_title: 'Épuisement des stocks',
  why_f4_desc: "Au printemps, les stocks de blé de l'année précédente sont critiquement bas, créant une pénurie d'offre qui fait monter les prix.",
  why_f4_stat: '-35%',
  why_f4_label: 'stocks restants',
  why_f5_title: 'Anticipations du marché',
  why_f5_desc: "Le marché intègre l'incertitude sur la prochaine récolte — ce qui augmente la volatilité et le potentiel de croissance.",
  why_f5_stat: '+33%',
  why_f5_label: 'croissance de la volatilité',
  why_stat1_val: '+42%',
  why_stat1_label: 'Croissance moyenne sur 5 ans',
  why_text: "Selon les statistiques des années passées, le printemps est l'une des périodes de croissance des prix les plus actives pour le",
  why_wheat: 'Blé',
  why_disclaimer: 'Données historiques CME Group, USDA · pas un conseil financier',
  why_stat2_val: '100%',
  why_stat2_label: 'Années avec croissance (5/5)',

  pkg_badge: 'Contrats d\'investissement',
  pkg_title_1: 'Choisissez votre',
  pkg_title_2: 'contrat',
  pkg_title_3: "d'investissement",
  pkg_subtitle: 'Trois niveaux de participation — doublez, triplez ou quadruplez votre capital',
  pkg_investment: 'Investissement',
  pkg_term: 'Durée',
  pkg_term_val: '2 jours',
  pkg_yield: 'Rendement',
  pkg_profit_label: 'Profit net en 2 jours',
  pkg_invested: 'Investi :',
  pkg_total: 'Total récupéré :',
  pkg_btn: 'Commencer à investir',
  pkg_disclaimer: '* Toutes les données de rendement sont basées sur la dynamique historique du marché. Les investissements comportent des risques.',
  pkg_popular: 'Populaire',
  pkg_maximum: 'Maximum',
  pkg_p1_name: 'Contrat Débutant',
  pkg_p1_sub: 'Investissements blé · 2 jours',
  pkg_p1_f1: 'Seuil d\'entrée — €21 100',
  pkg_p1_f2: 'Profit ×2 en 2 jours',
  pkg_p1_f3: 'Rapport mensuel',
  pkg_p1_f4: 'Support 5/7',
  pkg_p1_f5: 'Compte personnel',
  pkg_p2_name: 'Contrat Équilibré',
  pkg_p2_sub: 'Investissements blé · 2 jours',
  pkg_p2_f1: 'Seuil d\'entrée — €26 000',
  pkg_p2_f2: 'Profit ×3 en 2 jours',
  pkg_p2_f3: 'Rapport hebdomadaire',
  pkg_p2_f4: 'Support prioritaire',
  pkg_p2_f5: 'Compte personnel',
  pkg_p2_f6: 'Analyses de marché',
  pkg_p3_name: 'Contrat Premium',
  pkg_p3_sub: 'Investissements blé · 2 jours',
  pkg_p3_f1: 'Seuil d\'entrée — €31 000',
  pkg_p3_f2: 'Profit ×4 en 2 jours',
  pkg_p3_f3: 'Rapport quotidien',
  pkg_p3_f4: 'Support VIP 7/7',
  pkg_p3_f5: 'Compte personnel',
  pkg_p3_f6: 'Analyses de marché',
  pkg_p3_f7: 'Gestionnaire personnel',

  calc_badge: 'Calculateur de rendement',
  calc_title_1: 'Calculez',
  calc_title_2: 'votre profit',
  calc_subtitle: 'Entrez les paramètres et découvrez le revenu attendu',
  calc_amount_label: "Montant de l'investissement",
  calc_package_label: "Forfait d'investissement",
  calc_duration_label: "Durée de l'investissement",
  calc_duration_val: '2 jours',
  calc_duration_note: 'Durée fixe pour tous les contrats',
  calc_result_title: 'Résultat du calcul',
  calc_multiplier: 'multiplicateur',
  calc_net_profit: 'Profit net',
  calc_yield: 'rendement / 2 jours',
  calc_total: 'Montant total récupéré',
  calc_invested_label: 'Investissement',
  calc_package_row: 'Forfait',
  calc_period: 'Période',
  calc_period_val: '2 jours',
  calc_bar_invested: 'Investi',
  calc_bar_profit: 'Profit',
  calc_choose_btn: 'Choisir un contrat',

  act_badge: 'Communauté d\'investisseurs',
  act_title_1: 'Des milliers d\'investisseurs',
  act_title_2: 'gagnent déjà avec nous',
  act_desc: "Chaque jour, nos clients multiplient leur capital grâce à la tendance saisonnière printanière du blé. Rejoignez des milliers d'investisseurs qui utilisent ce cycle chaque année.",
  act_join: 'Rejoindre',
  act_view: 'Voir les forfaits',
  act_stat1_val: '12 400+',
  act_stat1_label: 'Investisseurs actifs',
  act_stat2_val: '€28M+',
  act_stat2_label: 'Actifs sous gestion',
  act_stat3_val: '97%',
  act_stat3_label: 'Clients satisfaits',
  act_live_title: 'Activité de la plateforme',
  act_live_note: "démonstration en temps réel de l'activité des utilisateurs",
  act_invested: 'a investi',
  act_earned: 'a gagné',
  act_now: 'maintenant',

  trust_badge: 'Pourquoi nous faire confiance',
  trust_title_1: 'Fiabilité prouvée par',
  trust_title_2: 'le temps',
  trust_subtitle: "Le blé est l'actif agricole le plus liquide et prévisible au monde",
  trust_c1_title: "L'instrument de trading le plus ancien",
  trust_c1_desc: "Le blé est l'une des marchandises les plus anciennes de l'histoire humaine — un instrument d'investissement saisonnier éprouvé depuis des siècles.",
  trust_c2_title: 'Actif agricole mondial N°1',
  trust_c2_desc: 'Le blé est le premier actif agricole mondial par volume de trading et liquidité sur les bourses CME et CBOT.',
  trust_c3_title: 'Volatilité printanière accrue',
  trust_c3_desc: 'Le printemps montre historiquement la plus haute volatilité et le plus grand potentiel de croissance, créant des opportunités de profit uniques.',
  trust_s1_val: '200+',
  trust_s1_label: "ans d'histoire du marché",
  trust_s2_val: '€120B+',
  trust_s2_label: 'volume de trading annuel',
  trust_s3_val: '#1',
  trust_s3_label: 'actif agricole mondial',
  trust_s4_val: '99%',
  trust_s4_label: 'liquidité de position',
  trust_cta_text: 'Prêt à profiter de la tendance printanière du blé ? Calculez votre profit potentiel maintenant.',
  trust_cta_btn: 'Calculer le profit maintenant',

  footer_tagline: '— Investissements saisonniers en blé',
  footer_copy: '© 2025 WheatVest. Pas un conseil financier.',

  toast_invested: 'a investi',
  toast_earned: 'a gagné',
};

export default fr;
